import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import * as Sentry from "@sentry/react";
import App from './App.tsx'
import './index.css'
import LoginPage from './pages/LoginPage.tsx'
import DashboardPage from './pages/DashboardPage.tsx'
import BuildingsPage from './pages/BuildingsPage.tsx'
import BuildingDetailPage from './pages/BuildingDetailPage.tsx'
import TenantsPage from './pages/TenantsPage.tsx'
import TenantDetailPage from './pages/TenantDetailPage.tsx'
import TenantStatementPage from './pages/TenantStatementPage.tsx'
import DelinquentTenantsReport from './pages/DelinquentTenantsReport.tsx'
import AuthLayout from './components/layout/AuthLayout.tsx'
import { Toaster } from './components/ui/sonner.tsx'

Sentry.init({
  dsn: "https://0ad1cd05411a22d66d89fd665151cde8@o117343.ingest.us.sentry.io/4509755817656320",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost:5173", "localhost", /^https:\/\/inquilapp\.pages\.dev/],
  // Session Replay
  replaysSessionSampleRate: 1.0, // Lowered to 10% in production
  replaysOnErrorSampleRate: 1.0, // Keep 100% sampling for sessions with errors
  // Logs
  enableLogs: true
});

const SentryErrorBoundary = Sentry.ErrorBoundary;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<p>Ha ocurrido un error inesperado.</p>}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={
            <AuthLayout>
              <DashboardPage />
            </AuthLayout>
          } />
          <Route path="/buildings" element={
            <AuthLayout>
              <BuildingsPage />
            </AuthLayout>
          } />
          <Route path="/buildings/:id" element={
            <AuthLayout>
              <BuildingDetailPage />
            </AuthLayout>
          } />
          <Route path="/tenants" element={
            <AuthLayout>
              <TenantsPage />
            </AuthLayout>
          } />
          <Route path="/tenants/:id" element={
            <AuthLayout>
              <TenantDetailPage />
            </AuthLayout>
          } />
          <Route path="/tenants/:id/statement" element={
            <AuthLayout>
              <TenantStatementPage />
            </AuthLayout>
          } />
          <Route path="/reports/delinquent-tenants" element={
            <AuthLayout>
              <DelinquentTenantsReport />
            </AuthLayout>
          } />
          <Route path="*" element={<App />} /> {/* Fallback for now */}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </SentryErrorBoundary>
  </React.StrictMode>,
)
